import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";
import { HashLink } from "react-router-hash-link";

function Navbar() {
  const [hideNavbar, setHideNavbar] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    let lastScrollY = window.scrollY; // mettre localement ici

    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        setHideNavbar(true);
      } else {
        setHideNavbar(false);
      }

      lastScrollY = currentScrollY; // update local, pas dans state
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Toggle mobile menu
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <nav className={`navbar ${hideNavbar ? "hide" : ""}`}>
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          <img
            src="/images/photo (1).jpeg"
            alt="Ebeeny"
            className="logo-image"
          />
        </Link>

        <div className="menu-icon" onClick={toggleMenu}>
          <div className={`menu-icon-bar ${menuOpen ? "open" : ""}`}></div>
          <div className={`menu-icon-bar ${menuOpen ? "open" : ""}`}></div>
          <div className={`menu-icon-bar ${menuOpen ? "open" : ""}`}></div>
        </div>

        <ul className={`nav-menu ${menuOpen ? "active" : ""}`}>
          <li className="nav-item">
            <Link
              to="/"
              className="nav-link"
              onClick={() => setMenuOpen(false)}
            >
              Accueil
            </Link>
          </li>
          <li className="nav-item">
            <Link
              to="/menus"
              className="nav-link"
              onClick={() => setMenuOpen(false)}
            >
              Les Menus
            </Link>
          </li>
          <li className="nav-item">
            <HashLink
              smooth
              to="/#contact"
              className="nav-link social"
              onClick={() => setMenuOpen(false)}
            >
              Contact
            </HashLink>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
